import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, authGuardSubmodule } from './auth/auth.guard';
import { ContenedorComponent } from './elements/contenedor/contenedor.component';
import { InicioComponent } from './elements/inicio/inicio.component';
import { Cuestionariov2Component } from './elements/cuestionarios/cuestionariov2/cuestionariov2.component';

const PATH = 'app';
const routes: Routes = [
  {
    path: '',
    redirectTo: '/'+PATH,
    pathMatch: 'full',
  },
  {
    path: PATH,
    component: ContenedorComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivateChild: [authGuard],
        children: [
          {path: '', component: InicioComponent, canActivate: [authGuardSubmodule]},
          {path: 'inicio', component: InicioComponent, canActivate: [authGuardSubmodule]},
        ],
      }
    ]
  },
  {path: 'cuestionario/:hash',  component: Cuestionariov2Component},
  {
    path: 'controller',
    redirectTo: '/'+PATH,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
